module.exports = __webpack_public_path__ + "img/ico-reply-yes.623be94d.svg";